import "./Footer.scss";
import facebookIcon from "../../../assets/images/facebook-icon.png";
import twitterIcon from "../../../assets/images/twitter-icon.png";
import youtubeIcon from "../../../assets/images/youtube-icon.png";
import instagramIcon from "../../../assets/images/instagram-icon.png";
import linkedinIcon from "../../../assets/images/linkedin-icon.png";
import { Link } from 'react-router-dom';

function Footer(props) {
    const APP_VERSION = process.env.REACT_APP_VERSION;
  return (
    <footer className="mt-20">
      <nav className="footer-blue">
        {/*<div className="social-media-icons">*/}
        {/*  <ul className="icons">*/}
        {/*    <li>*/}
        {/*      <a*/}
        {/*        className="v-align-center fx-shadow fx-scale"*/}
        {/*        rel="noreferrer"*/}
        {/*        target="_blank"*/}
        {/*        href="https://www.facebook.com/EssilorPRO/"*/}
        {/*      >*/}
        {/*        <img*/}
        {/*          alt="facebook icon"*/}
        {/*          src={facebookIcon}>*/}
        {/*        </img>*/}
        {/*      </a>*/}
        {/*    </li>*/}

        {/*    <li>*/}
        {/*      <a*/}
        {/*        className="v-align-center fx-shadow fx-scale"*/}
        {/*        rel="noreferrer"*/}
        {/*        target="_blank"*/}
        {/*        href="https://twitter.com/essilorpro"*/}
        {/*      >*/}
        {/*        <img*/}
        {/*          alt="twitter icon"*/}
        {/*          src={twitterIcon}>*/}
        {/*        </img>*/}
        {/*      </a>*/}
        {/*    </li>*/}

        {/*    <li>*/}
        {/*      <a*/}
        {/*        className="v-align-center fx-shadow fx-scale"*/}
        {/*        rel="noreferrer"*/}
        {/*        target="_blank"*/}
        {/*        href="https://www.youtube.com/user/EssilorUSA1"*/}
        {/*      >*/}
        {/*        <img*/}
        {/*          alt="youtube icon"*/}
        {/*          src={youtubeIcon}>*/}
        {/*        </img>*/}
        {/*      </a>*/}
        {/*    </li>*/}

        {/*    <li>*/}
        {/*      <a*/}
        {/*        className="v-align-center fx-shadow fx-scale"*/}
        {/*        rel="noreferrer"*/}
        {/*        target="_blank"*/}
        {/*        href="https://www.instagram.com/essilorpro/"*/}
        {/*      >*/}
        {/*        <img*/}
        {/*          alt="instagram icon"*/}
        {/*          src={instagramIcon}>*/}
        {/*        </img>*/}
        {/*      </a>*/}
        {/*    </li>*/}

        {/*    <li>*/}
        {/*      <a*/}
        {/*        className="v-align-center fx-shadow fx-scale"*/}
        {/*        rel="noreferrer"*/}
        {/*        target="_blank"*/}
        {/*        href="https://www.linkedin.com/showcase/essilor-america"*/}
        {/*      >*/}
        {/*        <img*/}
        {/*          alt="linkedin icon"*/}
        {/*          src={linkedinIcon}>*/}
        {/*        </img>*/}
        {/*      </a>*/}
        {/*    </li>*/}
        {/*  </ul>*/}
        {/*</div>*/}
        {/*<div className="text-items">*/}
        {/*  <ul className="text">*/}
        {/*    <li>*/}
        {/*      <a href="/">OUR COMPANY</a>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <a href="/">CAREERS</a>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <a href="/">NEWSROOM</a>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <a href="/">ESSILOR GROUP</a>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <a href="/">CONTACT US</a>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <a href="/">HELP</a>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <Link to="/help/faq">FAQ</Link>*/}
        {/*    </li>*/}
        {/*  </ul>*/}
        {/*</div>*/}
      </nav>
      <nav className="footer-gray">
        <div className="copyright">©2022 ALL RIGHTS RESERVED. ({APP_VERSION}) </div>
        {/*<ul className="text">*/}
        {/*  <li>*/}
        {/*    <a href="/">Terms of Use</a>*/}
        {/*  </li>*/}
        {/*  <li>*/}
        {/*    <a href="/">Privacy Policy</a>*/}
        {/*  </li>*/}
        {/*  <li>*/}
        {/*    <a href="/">Ethics & Compliance</a>*/}
        {/*  </li>*/}
        {/*</ul>*/}
      </nav>
    </footer>
  );
}

export default Footer;
